/**
 * legacyHostInterceptor — força MESMA ORIGEM para qualquer chamada que
 * o bundle (eventualmente compilado com REACT_APP_BACKEND_URL legacy)
 * tente fazer para domínios bloqueados. Resolve o caso em produção onde
 * o env var de build está stale apontando para `dnahub-school-1.emergent.host`.
 *
 * Aplicado UMA vez, no bootstrap do app, antes de qualquer chamada.
 */
const _BLOCKED_HOSTS = [
  'dnahub-school-1.emergent.host',
  'localhost',
  '127.0.0.1',
];

function _isBlocked(urlStr) {
  if (typeof urlStr !== 'string') return false;
  for (const h of _BLOCKED_HOSTS) {
    if (urlStr.includes(`://${h}`) || urlStr.includes(`//${h}`)) return true;
  }
  return false;
}

function _rewrite(urlStr) {
  if (!_isBlocked(urlStr)) return urlStr;
  try {
    const u = new URL(urlStr);
    // path + search + hash → relativo (mesma origem do navegador)
    return `${u.pathname || ''}${u.search || ''}${u.hash || ''}` || '/';
  } catch (_) {
    return urlStr;
  }
}

export function installLegacyHostInterceptor() {
  if (typeof window === 'undefined') return;
  if (window.__legacyHostInterceptorInstalled) return;
  window.__legacyHostInterceptorInstalled = true;

  // 1) fetch
  if (typeof window.fetch === 'function') {
    const _origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string' && _isBlocked(input)) {
          return _origFetch(_rewrite(input), init);
        }
        if (input && typeof input === 'object' && input.url && _isBlocked(input.url)) {
          const newUrl = _rewrite(input.url);
          return _origFetch(new Request(newUrl, input), init);
        }
      } catch (_) { /* noop */ }
      return _origFetch(input, init);
    };
  }

  // 2) XMLHttpRequest (axios usa)
  if (typeof window.XMLHttpRequest === 'function') {
    const _origOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      let finalUrl = url;
      try {
        if (typeof url === 'string' && _isBlocked(url)) {
          finalUrl = _rewrite(url);
        }
      } catch (_) { /* noop */ }
      return _origOpen.call(this, method, finalUrl, ...rest);
    };
  }
}
